import * as fromDatatype from '../datatype-library/index';

export interface bl_ppl_einvoice_waiting_queue_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  generic_doc_line_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  einvoice_to_irb_hdr_guid: fromDatatype.GuidDataFieldInterface;
  submission_status: fromDatatype.VarcharDatatypeInterface;
  submission_request_date: fromDatatype.TimestampTzDatatypeInterface;
  request_url: fromDatatype.TextDatatypeInterface;
  request_body: fromDatatype.TextDatatypeInterface;
  request_response: fromDatatype.TextDatatypeInterface;
  request_error: fromDatatype.TextDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  validation_error: fromDatatype.TextDatatypeInterface;
}

export class bl_ppl_einvoice_waiting_queue_RowClass
  implements bl_ppl_einvoice_waiting_queue_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    generic_doc_line_guid: fromDatatype.GuidDataFieldInterface;
    generic_doc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
    generic_doc_line_server_doc_type: fromDatatype.VarcharDatatypeInterface;
    einvoice_to_irb_hdr_guid: fromDatatype.GuidDataFieldInterface;
    submission_status: fromDatatype.VarcharDatatypeInterface;
    submission_request_date: fromDatatype.TimestampTzDatatypeInterface;
    request_url: fromDatatype.TextDatatypeInterface;
    request_body: fromDatatype.TextDatatypeInterface;
    request_response: fromDatatype.TextDatatypeInterface;
    request_error: fromDatatype.TextDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_by_name: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_name: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    validation_error: fromDatatype.TextDatatypeInterface;
}
